import React, { Component } from "react";
import axios from "axios";
import {
  Modal,
  Button,
  Col,
  OverlayTrigger,
  Popover,
  Form,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileUpload,
  faUpload,
  faQuestionCircle,
  faQrcode,
} from "@fortawesome/free-solid-svg-icons";
import { ToastContainer, toast } from "react-toastify";
import QRCode from "qrcode.react";
import ReactMomentCountDown from "react-moment-countdown";
import momentPropTypes from "react-moment-proptypes";
const fechafutura = "2021-01-31 17:18:43";
export default class Adjunto extends Component {
  constructor(props) {
    super(props);

    this.state = {
      photoIndex: 0,
      modalDocumentos: false,
      frm_descripcion_doc: "",
      frm_archivo: null,
      loading: false,
      codigo: "",
      caducidad: "",
    };
  }

  onFileChange = (event) => {
    this.setState({
      frm_archivo: event.target.files[0],
    });
  };

  sube_documento = (e) => {
    e.preventDefault();
    this.setState({ loading: true });

    let datosFormulario = new FormData();
    datosFormulario.append("archivo", this.state.frm_archivo);
    datosFormulario.append("usuario_id", localStorage.id);
    datosFormulario.append("api_token", localStorage.api_token);

    let config = {};
    axios
      .post(
        "http://143.198.191.211/api/Importa/" + this.props.ambito_id + "/" + this.props.formato,
        datosFormulario,
        config
      )
      .then((res) => {
        this.closeModalDocumentos();
        toast.success(res.data.text, { autoClose: 1000 });
        this.props.cargaTabla();
        this.setState({ loading: false });
      });
  };

  ModalDocumentos = () => {
    this.setState({ modalDocumentos: true });
  };

  onChangefrm_descripcion_doc = (e) => {
    this.setState({ frm_descripcion_doc: e.target.value });
  };

  closeModalDocumentos = () => {
    this.setState({ modalDocumentos: false });
  };

  render() {
    return (
      <div>
        <ToastContainer />
        <button
          type="button"
          className="btn btn-primary"
          size="sm"
          onClick={this.ModalDocumentos}
          data-tip="Cargar Archivo .xlsx"
          disabled={this.props.disabled}
        >
          <FontAwesomeIcon icon={faFileUpload} size="lg" /> CARGAR Excel
        </button>

        <Modal //*******************************Modal para Documentos
          show={this.state.modalDocumentos}
          onHide={this.closeModalDocumentos}
          dialogClassName="modal-90w"
          centered
        >
          <Modal.Header>
            <Modal.Title>Cargar Archivo Excel</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Modal.Body>
              <Form.Row>
                <Col xs="12">
                  <br />
                  <label htmlFor="file-upload" className="custom-file-upload">
                    <FontAwesomeIcon icon={faUpload} /> Seleccionar Archivo .xlsx
                  </label>
                  <input
                    id="file-upload"
                    type="file"
                    onChange={this.onFileChange}
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    className="btnSubir"
                  />
                </Col>
              </Form.Row>
            </Modal.Body>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={this.closeModalDocumentos}
              disabled={this.state.loading}
            >
              Cancelar
            </Button>
            <Button onClick={this.sube_documento} disabled={this.state.loading}>
              {this.state.loading ? "Subiendo archivo excel..." : "Cargar Archivo"}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
